
import React from "react";
import Breadcrumb from "./components/Breadcrumb";
import ContactContent from "./components/ContactContent";
import { BannerComponent} from '../../components'
function Contact(){
    return(
        <>
            <BannerComponent />
        <Breadcrumb />
        <ContactContent />
        </>
    )
}
export default Contact;